/**
 * Company: SPHMedia
 * Description: [Event Banner] To entry point based on the props page.
 */
import ChevronImage from "@assets/video_widget/Chevron.webp";
import { ReactElement } from "react";
import { Link } from "react-router";

type EventBannerProps = {
  link: string;
  title: string;
};

/**
 * EventBanner
 * @returns The rendered React element
 */
export default function EventBanner({
  link,
  title,
}: EventBannerProps): ReactElement {
  return (
    <div className="bg-gray-500 border-gray-2050 border-y w-full text-md font-bold leading-6 lg:leading-9 flex justify-items-start lg:justify-center items-center h-[52px] lg:h-[45px] my-5 px-[15px] py-2.5">
      <div className="hidden lg:block pr-2.5 text-gray-100">{title}</div>
      <div className="block lg:hidden pr-2.5 text-red-100 ">
        <Link reloadDocument to={link} target="_blank">
          {title} செய்திகள்
          <img
            alt="toggle-button-chevie"
            height={30}
            width={30}
            className="pl-[5px] inline"
            src={ChevronImage}
          />
        </Link>
      </div>

      <div className="text-red-100 hidden lg:block ">
        <Link reloadDocument to={link} target="_blank">
          அண்மைய செய்திகளைப் படிக்க
          <img
            alt="toggle-button-chevie"
            height={30}
            width={30}
            className="pl-[5px] inline"
            src={ChevronImage}
          />
        </Link>
      </div>
    </div>
  );
}
